import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect } from "react"
import {
  canEditCategoriasSelector,
  categoriasSelector,
  categoriasTreeObjSelector,
} from "../redux/selectors/categoriasSelectors"
import {
  getAllCategorias,
  getAllCategoriasPadre,
  getCategoriaAndPosiblesPadres,
  selectCategoria,
  setCategorias,
  updateCategoria,
} from "../redux/slices/categoriasSlice"

const useCategorias = () => {
  const { fetchingCategorias } = useSelector(categoriasSelector)
  const canEditCategorias = useSelector(canEditCategoriasSelector)
  const categorias = useSelector(categoriasTreeObjSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllCategoriasPadre())
    dispatch(getAllCategorias())
    dispatch(selectCategoria(null))
  }, [dispatch])

  const handleChangeCategorias = useCallback(
    (categorias: $TSMigrationFixMe) => {
      dispatch(setCategorias(categorias))
    },
    [dispatch]
  )

  const handleSelectCategoria = useCallback(
    (categoria: $TSMigrationFixMe) => {
      dispatch(getCategoriaAndPosiblesPadres(categoria.id))
    },
    [dispatch]
  )

  const handleUpdateCategorias = useCallback(
    ({ nextParentNode, node }: $TSMigrationFixMe) => {
      dispatch(
        // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
        updateCategoria({
          categoriaPadreId: nextParentNode?.id,
          id: node?.id,
          nombre: node?.title,
          imagenBase64: node?.fichero?.base64,
        })
      )
    },
    [dispatch]
  )

  return {
    fetchingCategorias,
    canEditCategorias,
    categorias,
    handleChangeCategorias,
    handleSelectCategoria,
    handleUpdateCategorias,
  }
}

export default useCategorias
